import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'ds-lib-input-password',
  templateUrl: './ds-lib-input-password.component.html',
  styleUrls: ['./ds-lib-input-password.component.css'],
})
export class DsLibInputPasswordComponent {
  /**
   * The password status
   */
  public showPassword = false;

  /**
   * A password/confirm form control
   */
  @Input() formControlPassword: AbstractControl;

  /**
   * The error message
   */
  @Input() errorMessage: string;

  /**
   * The input placeholder
   */
  @Input() placeholder: string;
}
